import {DATASETS} from '../constants'

export const datasets = {
  [DATASETS.GERAL]: {
    name: 'Geral',
    url: 'https://cdn.rawgit.com/felipemfp/ria/64ff17e55f990c9fad530d45d5c9d3fa5df7e3a9/data/geral.txt',
  },
  [DATASETS.FIC]: {
    name: 'FIC',
    url: 'https://cdn.rawgit.com/felipemfp/ria/64ff17e55f990c9fad530d45d5c9d3fa5df7e3a9/data/fic.txt',
  },
  [DATASETS.TECNOLOGIA]: {
    name: 'Tecnologia',
    url: 'https://cdn.rawgit.com/felipemfp/ria/64ff17e55f990c9fad530d45d5c9d3fa5df7e3a9/data/tecnologia.txt',
  }
}


// WEBPACK FOOTER //
// ./src/data/index.js